export function createElement({
  type,
  canvasRect,
  elements,
  payload = {},
}) {
  const defaults = getDefaults(type);

  const id = generateId(type, elements);
  const zIndex = getTopZIndex(elements);

  const { x, y } = getCenteredPosition(
    canvasRect,
    defaults.layout.width,
    defaults.layout.height
  );

  return {
    id,
    type,
    zIndex,

    // layout
    layout: {
      x,
      y,
      ...defaults.layout,
      ...(payload.layout || {}),
    },

    // content
    content: {
      ...defaults.content,
      ...(payload.content || {}),
    },

    // style
    style: {
      ...defaults.style,
      ...(payload.style || {}),
    },
  };
}

function getDefaults(type) {
  if (type === 'text') {
    return {
      layout: {
        width: 180,
        height: 80,
      },
      content: {
        text: 'New Text',
      },
      style: {
        backgroundColor: '#ffffff00',
        color: '#000000',
        fontSize: 22,
        fontWeight: 500,
        textAlign: 'center',
        borderWidth: 0,
      },
    };
  }

  if (type === 'image') {
    return {
      layout: {
        width: 200,
        height: 140,
      },
      content: {
        src: '',
        alt: '',
      },
      style: {
        objectFit: 'contain',
        backgroundColor: '#ffffff',
        borderWidth: 0,
      },
    };
  }

  throw new Error(`Unknown element type: ${type}`);
}


function generateId(type, elements) {
  const max = Math.max(
    0,
    ...elements
      .filter(e => e.type === type)
      .map(e => Number(e.id.split('-')[1]) || 0)
  );

  return `${type}-${max + 1}`;
}

function getTopZIndex(elements) {
  return Math.max(0, ...elements.map(e => e.zIndex || 0)) + 1;
}

function getCenteredPosition(canvasRect, width, height) {
  return {
    x: Math.round(canvasRect.width / 2 - width / 2),
    y: Math.round(canvasRect.height / 2 - height / 2),
  };
}
